/*
 * @Author: cgh
 * @Date: 2022-08-01 10:50:50
 * @LastEditors: cgh
 * @LastEditTime: 2022-08-01 18:33:33
 * @Description: 评估项目管理
 */

const pgyqRoutes = {
  path: 'pgyq',
  name: 'jxxfPgyq',
  component: { template: '<router-view></router-view>' },
  children: [
    {
      path: 'list',
      name: 'jxxfPgyqManage',
      component: () => import(/* webpackChunkName: "pgyqManageList" */ '@/features/jxxf/pg/pgyqgl/list.vue'),
      meta: {
        navtabTitle: '评估仪器管理',
        isCache: true,
        ignoreDiff: [],
        isSecondary: false
      }
    }
  ]
};

export default pgyqRoutes;
